import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

// 静态路由（无需权限）
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/life',
    component: Layout,
    children: [
      {
        path: '',
        name: 'LoveLife',
        component: () => import('@/views/life/index.vue'),
        meta: { title: '小窝日常', icon: 'el-icon-sugar' }
      }
    ]
  },
  {
    path: '/dish',
    component: Layout,
    redirect: '/dish/list',
    meta: { title: '点菜管理', icon: 'el-icon-food' },
    children: [
      {
        path: 'category',
        name: 'DishCategory',
        component: () => import('@/views/dish/category/index.vue'),
        meta: { title: '菜品分类', icon: 'el-icon-menu' }
      },
      {
        path: 'list',
        name: 'DishList',
        component: () => import('@/views/dish/list/index.vue'),
        meta: { title: '菜品列表', icon: 'el-icon-dish' }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Order',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-order' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/user',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'user',
        name: 'SysUser',
        component: () => import('@/views/system/user/index.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'role',
        name: 'SysRole',
        component: () => import('@/views/system/role/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'menu',
        name: 'SysMenu',
        component: () => import('@/views/system/menu/index.vue'),
        meta: { title: '菜单管理', icon: 'el-icon-menu' }
      },
      {
        path: 'permission',
        name: 'SysPermission',
        component: () => import('@/views/system/permission/index.vue'),
        meta: { title: '权限管理', icon: 'el-icon-key' }
      }
    ]
  }
]

const createRouter = () => new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
